// extracted by mini-css-extract-plugin
export default {"CheckboxList__list":"CheckboxList_CheckboxList__list__gdOUB","CheckboxList":"CheckboxList_CheckboxList__Fp80G"};